module.exports = __webpack_public_path__ + "operace-nosu_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_3_after.jpg
// module id = 1133
// module chunks = 0